import React from 'react';
import PropTypes from 'prop-types';

export class StatsTile extends React.Component {
  static propTypes = {
    stats: PropTypes.any
  };

  renderColor() {
    let { stats } = this.props;
    let color = 'transparent';
    let content = '';

    if (typeof stats === 'number') {
      if (stats > -1 && stats < 50) {
        color = 'red';
        content = `${stats} %`;
      }
      if (stats >= 50 && stats < 70) {
        color = 'orange';
        content = `${stats} %`;
      }
      if (stats >= 70) {
        color = 'green';
        content = `${stats} %`;
      }
    } else if (stats === null) {
      color = 'gray';
      content = '...';
    }
    return { color, content };
  }

  render() {
    let styles = this.renderColor();
    return <div className={`basic-analytics-tiles ${styles.color}-bg`}>{styles.content}</div>;
  }
}
export default StatsTile;
